import { inject, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@guard/auth.service';
import { AccessRight } from '@constants/enum';

@Pipe({
  name: 'allRights',
})
export class AllRightsPipe implements PipeTransform {
  private readonly authService = inject(AuthService);

  transform(rights: AccessRight[]): boolean {
    return this.authService.hasAllRights(rights);
  }
}
